import React from "react";


/**
 * @param {*} props - passData   = the props to pass to the children in the sub-tab
 */
function SubTabParent(props) {

  // Create a clone of the provided sub-tab's content, and give it the user, project, and extra data
  let children = React.Children.toArray(props.children);
  let childrenWithData = children.map((child) => { return React.cloneElement(child, {...props.passData})});

  return (
    <div>
      {childrenWithData}
    </div>
  )

}

export default SubTabParent;